import {ALL_FREQUENCIES} from '../consts'
import {JobsToBeDone, JobsToBeDoneTaskWithContext} from '../types'

export const extractUniqueFrequencies = (data: JobsToBeDone[]): string[] => {
  const frequencySet = new Set<string>()
  data.forEach((jtbd) => {
    jtbd.activities?.forEach((activity) => {
      ;(activity.activityTasks ?? []).forEach((task) => {
        if (task.frequency) {
          frequencySet.add(task.frequency)
        }
      })
    })
  })
  return Array.from(frequencySet)
}

/** Flatten the JTBD hierarchy into a list of tasks with parent context */
export const flattenTasksWithContext = (data: JobsToBeDone[]): JobsToBeDoneTaskWithContext[] => {
  const tasks: JobsToBeDoneTaskWithContext[] = []
  data.forEach((jtbd) => {
    jtbd.activities?.forEach((activity) => {
      ;(activity.activityTasks ?? []).forEach((task) => {
        const existing = task as Partial<JobsToBeDoneTaskWithContext>
        tasks.push({
          ...task,
          jobToBeDoneId: existing.jobToBeDoneId ?? jtbd.id,
          jobsToBeDoneTitle: existing.jobsToBeDoneTitle ?? jtbd.title,
          activityId: existing.activityId ?? activity.id,
          activityTitle: existing.activityTitle ?? activity.title
        })
      })
    })
  })
  return tasks
}

export const filterAndGroupByFrequency = (
  data: JobsToBeDone[],
  selectedFrequency: string
): JobsToBeDone[] => {
  if (selectedFrequency === ALL_FREQUENCIES) {
    return data
  }

  // When filtering by frequency, collect all tasks matching the frequency
  const filteredTasks: JobsToBeDoneTaskWithContext[] = []

  data.forEach((jtbd) => {
    jtbd.activities?.forEach((activity) => {
      ;(activity.activityTasks ?? []).forEach((task) => {
        if (task.frequency === selectedFrequency) {
          filteredTasks.push({
            ...task,
            jobToBeDoneId: jtbd.id,
            jobsToBeDoneTitle: jtbd.title,
            activityId: activity.id,
            activityTitle: activity.title
          })
        }
      })
    })
  })

  // Sort tasks alphabetically by title
  filteredTasks.sort((a, b) => a.title.localeCompare(b.title))

  if (filteredTasks.length === 0) {
    return []
  }

  // Return as a single group with filtered tasks wrapped in a synthetic activity
  return [
    {
      id: `frequency-${selectedFrequency}`,
      title: `${selectedFrequency} tasks`,
      associatedRole: data[0]?.associatedRole || '',
      activities: [
        {
          id: `frequency-activity-${selectedFrequency}`,
          title: `${selectedFrequency} tasks`,
          activityTasks: filteredTasks
        }
      ]
    }
  ]
}
